import { render, staticRenderFns } from "./ReceiptPaymentView.vue?vue&type=template&id=abd55a6c"
import script from "./ReceiptPaymentView.vue?vue&type=script&lang=js"
export * from "./ReceiptPaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abd55a6c')) {
      api.createRecord('abd55a6c', component.options)
    } else {
      api.reload('abd55a6c', component.options)
    }
    module.hot.accept("./ReceiptPaymentView.vue?vue&type=template&id=abd55a6c", function () {
      api.rerender('abd55a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/receiptpayment/ReceiptPaymentView.vue"
export default component.exports